import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private params: any = {};
  private multiple :any = { active: false }
  branch:any = {}
  private baseURL: string = 'http://209.250.237.58:5010/api';
  // private baseURL: string = 'http://localhost:5010/api';
  // private baseURL: string = 'http://192.168.1.4:5010';

  constructor(private http: HttpClient,) {}

  setParams(body: any) {
    this.params = body;
  }

  getParams() {
    return this.params;
  }

  get multi() {
    return this.multiple.active
  }

  setMulti(multi:any) {
    this.multiple = multi
  }


  getData(endPoint: string) {
    return this.http.get(this.baseURL + endPoint).pipe(take(1))
  }

  postData(endPoint: string, body: any) {
    return this.http.post(this.baseURL + endPoint, body).pipe(take(1));
  }

  updateData(endPoint: string, body: any) {
    return this.http.put(this.baseURL + endPoint, body).pipe(take(1));
  }

  deleteDate(endPoint: string) {
    return this.http.delete(this.baseURL + endPoint).pipe(take(1));
  }

  // OTP
  postOtp(endPoint: string, body: any) {
    return this.http
      .post('http://209.250.237.58:3016' + endPoint, body)
      .pipe(take(1));
  }

  async setApi(api:string) {
    this.baseURL = api.includes("http") ? api :  `http://${api}` ;
  }




}
